/**
 * 图片加载处理工具类
 * 优势：
 *  1、增加默认图片展示
 *  2、相比vue绑定onerror事件的方式处理的话，自定义指令处理，图片加载不会进入死循环；
 *  3、当进入页面时优先展示默认图片，如果真实图片地址有效则替换默认图片；达到占位效果；就算图片过大也会滞后加载，更好的用户体验
 */


/**
 * 检测图片是否有效
 * @param {Object} url 图片的真实地址
 */
const imgIsAvailable = function(url) {
  return new Promise((resolve) => {
    let img = new Image()
    img.onload = function() {
      if (this.complete == true) {
        resolve(true)
        img = null
      }
    }
    img.onerror = function() {
      resolve(false)
      img = null
    }
    img.src = url
  })
}
export default async function(el, binding) {
  //获取图片地址
  let url = binding.value;
  //校验图片地址是否有效
  let available = await imgIsAvailable(url)
  //图片有校则将有效的URL赋值给src
  if (available) {
    el.setAttribute('src', url)
  }
}
